// extracted by mini-css-extract-plugin
export default {"blog-page":"Blog_blog-page__Nd+hD","blog-header-container":"Blog_blog-header-container__WWkPX"};